import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';

const theme = {
  palette: {
    type: 'light',
    background: {
      dock: '#252529',
    },
    appMenuItems: {
      selected: 'rgba( 0,103,252, 0.05 )',
      active: 'rgba( 0,103,252, 0.03 )',
      hover: 'rgba( 0,103,252, 0.03 )',
    },
    primary: {
      light: '#5699FB',
      main: '#0067FC',
      dark: '#055cda',
      contrastText: '#fff',
    },
    success: {
      main: green['500'],
      dark: green['800'],
      light: green['200'],
      contrastText: '#fff',
    },
    warning: {
      main: orange['400'],
      dark: orange['800'],
      light: orange['200'],
      contrastText: '#fff',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        letterSpacing: 'initial',
      },
      contained: {
        boxShadow: 'none',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '8px 24px 24px',
      },
    },
    MuiCardHeader: {
      action: {
        marginTop: 0,
        marginRight: 0,
      },
    },
    MuiTableCell: {
      root: {
        padding: '14px 16px',
      },
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: 'rgba(0, 112, 251, 0.04)',
          '&:hover': {
            backgroundColor: 'rgba(0, 112, 251, 0.04)',
          },
        },
      },
    },
    MuiCard: {
      root: {
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.06)',
      },
    },
  },
  pageWidth: 800,
  drawerWidth: 296,
};

export default theme;
